import { useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";
import { IPreferences } from "../../logic/api";
import EditableField, {
    EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import EditableGroup, {
    EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";
import { SessionContext } from "../../utility/useSession";
import styles from "./styles";
import { useTranslation } from "react-i18next";

interface MeetAndGreetSettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const MeetAndGreetSettings = ({ onSave }: MeetAndGreetSettingsProps) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (!session.current.site) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <NotchedCard label={t("settings.meetAndGreet")} style={styles.card}>
                <EditableGroup<IPreferences>
                    id="meetAndGreetSettings"
                    editType={EditableGroupType.switchableEditing}
                    data={session.current.site.preferences}
                    onDataChanged={(data) => onSave({
                        meetAndGreetEnabled: data.meetAndGreetEnabled,
                    })}
                    testId="meet-and-greet-settings"
                >
                    <Grid container>
                        <Grid item sm={2} xs={6}>
                            <EditableField<IPreferences, boolean>
                                useFullWidthWhenEditing={false}
                                inputType={EditableFieldTypes.switch}
                                label={t("reports.enabled")}
                                onProvide={(data) =>
                                    Boolean(data.meetAndGreetEnabled)
                                }
                                onChange={(data, value) =>
                                    data.meetAndGreetEnabled = Boolean(value)
                                }
                                testId="settings-meet-and-greet-enabled-switch"
                            />
                        </Grid>
                    </Grid>
                </EditableGroup>
            </NotchedCard>
        </Grid>
    );
};
